import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import {
  CSV_NEW_SAMPLE_FILE_PATH,
  VIEW_VALID_CSV_FORMAT,
} from '../../../../constants'

import { DISTRESS } from 'app/constants/statusColors'
import useFeatureFlag from 'app/configs/useFeatureFlag'
import DownloadIcon from 'app/components/icons/DownloadIcon'

// import Dialog from 'app/componentV4/Dialog/Dialog'

import useStyles from './styles'
import PanelsInfo from 'app/componentV4/Panels/Info'

export default (props) => {
  const { getRootProps, getInputProps, toggleDialogs } = props
  const classes = useStyles()
  const { mes_3653_limit_import_csv_300 } = useFeatureFlag()

  const simpleCSVPath = CSV_NEW_SAMPLE_FILE_PATH

  const handlerViewValidCSVFormat = () => {
    toggleDialogs(VIEW_VALID_CSV_FORMAT, true)
  }

  return (
    <>
      <div className={classes.importBox} {...getRootProps()}>
        <input {...getInputProps()} />
        <p>
          <FormattedMessage id="subscribers.import.drag.text1" />
        </p>
        <p>
          <FormattedMessage id="subscribers.import.drag.text2" />
        </p>
        <div className={classes.importBtn}>
          <FormattedMessage id="subscribers.import.uploadBtn.label" />
        </div>
      </div>
      <div className={classes.infoCSVFileWrapp}>
        <p onClick={handlerViewValidCSVFormat}>
          <FormattedMessage id="subscriber.viewValidCSVbtn.label" />
        </p>
        <Button
          disableRipple={true}
          href={simpleCSVPath}
          download
          className={classes.boxCSVDownloadBtn}
        >
          <div className="flex">
            <DownloadIcon color="#075985" />
          </div>
          <FormattedMessage id="subscribers.downloadSampleBtn.label" />
        </Button>
      </div>
      {mes_3653_limit_import_csv_300 && (
        <PanelsInfo
          type={DISTRESS}
          className="my-10 flex space-x-3 items-center mx-32"
        >
          <Typography className="text-16 text-orange-600">
            <FormattedMessage
              id="subscribers.import.info.csv.limit"
              values={{
                b: (text) => (
                  <b>
                    <a
                      href={`mailto:${text}`}
                      className="text-orange-600 underline underline-offset-1"
                    >
                      {text}
                    </a>
                  </b>
                ),
              }}
            />
          </Typography>
        </PanelsInfo>
      )}
    </>
  )
}
